import { inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

const APP_NAME = 'Fairway Home Mortgage Protection Plan';

@Injectable()
export class PageTitleStrategy extends TitleStrategy {
    private readonly title = inject(Title);
    private readonly translate = inject(TranslateService);

    override updateTitle(snapshot: RouterStateSnapshot): void {
        const pageTitle = this.buildTitle(snapshot);
        // Route titles can be plain English strings or i18n keys (e.g.
        // "STEPS.PAYMENT.SUBSTEPS.FINAL_CONSENTS.TITLE"). TranslateService.instant
        // returns the input unchanged if no matching key exists, so this is safe
        // for both shapes.
        const localized = pageTitle ? this.translate.instant(pageTitle) : '';
        this.title.setTitle(localized ? `${localized} | ${APP_NAME}` : APP_NAME);
    }
}
